import request from '@/utils/requestLongTime'
import Qs from 'qs'

export function creatOrder(data) {
  return request({
    url: '/order/creatOrder',
    method: 'Post',
    data
  })
}

export function selectCarList(userId) {
  return request({
    url: '/car/queryCarByUserId',
    method: 'get',
    params: {userId}
  })
}

export function queryCarByString(gids) {
  return request({
    url: '/car/queryCarByString',
    method: 'get',
    params: {gids}
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js